// These are limits that were requested by a member of the IT Security team.

export const limits = {
    maxUrlLength: 2048, // (ecoffman) Mary and I discussed. This should be the value for now and can be revisited as appropriate.
    outputProgressDescriptionLength: 2000,
    outputStatementLength: 750,
};
